import { Immutable } from "immer";
import React from "react";

import { assertNever } from "../../../utils/never";
import { PLCBooleanOptionSelectorGroup } from "../PLCBooleanOptionSelectorGroup";
import { PLCMattressFeelOptionSelector } from "../PLCMattressFeelOptionSelector";
import { PLCMattressSizeOptionSelector } from "../PLCMattressSizeOptionSelector";
import { PLCOtherOptionSelector } from "../PLCOtherOptionSelector";
import {
    IPLCOptionPanel,
    IPLCProductCategorySelector,
    IPLCProductOptionSelector,
} from "../models";

type IProps = Immutable<{
    categorySelectors: readonly IPLCProductCategorySelector[];
    optionPanels: readonly IPLCOptionPanel[];
    selector: IPLCProductOptionSelector;
}>;

export const PLCProductOptionSelector = (props: IProps): React.JSX.Element => {
    const { categorySelectors, optionPanels, selector } = props;
    switch (selector.type) {
        case "mattress_size":
            return (
                <PLCMattressSizeOptionSelector
                    categorySelectors={categorySelectors}
                    optionPanels={optionPanels}
                    selector={selector}
                />
            );
        case "mattress_feel":
            return (
                <PLCMattressFeelOptionSelector
                    categorySelectors={categorySelectors}
                    optionPanels={optionPanels}
                    selector={selector}
                />
            );
        case "boolean_option_group":
            return (
                <PLCBooleanOptionSelectorGroup
                    categorySelectors={categorySelectors}
                    optionPanels={optionPanels}
                    group={selector}
                />
            );
        case "other":
            return (
                <PLCOtherOptionSelector
                    categorySelectors={categorySelectors}
                    optionPanels={optionPanels}
                    selector={selector}
                />
            );
    }
    throw assertNever(selector);
};
